/** @module                 React */

import { useState }         from "react";

/** @module                 Apollo */

import { useMutation }      from "@apollo/client";

const 

/** 
 * 
 * @returns useRemove hook for removing entry
 * 
 */

useRemove = ( MUTATION ) => { const 

    /** @hooks */

    [ loading,  setLoading  ]       = useState ( false ),

    [ errors,   setErrors   ]       = useState ( null ),

    [ complete, setComplete ]       = useState ( false ),

    /** @mutations */

    [ RemoveEntry ] = useMutation ( MUTATION, {

        /** @event onComplete */

        onCompleted ( data ) {

            setLoading ( false );

            // GraphQL can return HTTP 200 with errors + null data; only mark complete on success.
            const payload = data && Object.values ( data )[ 0 ];

            if ( payload == null ) {

                setErrors ( { message: "Request failed" } );

                return;

            }

            setComplete ( true );

        },

        /** @event onError */

        onError ( err ) {

            setLoading ( false );

            setComplete ( false );

            const message =
                err?.graphQLErrors?.[ 0 ]?.message ||
                err?.message ||
                "Internal Server Error";

            setErrors ( { message } );

        }

    } ),

    /** 
     * 
     * @param { Object } data
     * 
     * @returns remove entry action
     * 
     */

    removeMutation = ( data ) => {

        /** @override hook states */

        setErrors ( null ); setLoading ( true ); setComplete ( false );

        /** @mutation */

        RemoveEntry ( { variables: data } );

    }

    /** @returns */

    return { removeMutation, loading, complete, errors }

};

/** @exports useRemove */

export default useRemove;
